var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-badge",
        {
          staticClass: "item",
          attrs: {
            hidden: _vm.unreadCount < 1,
            value: _vm.unreadCount,
            max: 10
          }
        },
        [
          _c("el-button", {
            staticStyle: { "margin-left": "15px" },
            attrs: {
              type: "warning",
              icon: "el-icon-message-solid",
              circle: "",
              title: "消息通知"
            },
            on: { click: _vm.handleSearch }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "消息列表",
            visible: _vm.listDialogVisible,
            width: "800px",
            top: "50px",
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.listDialogVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "xx-out" },
            [
              _vm._l(_vm.messageList, function(item) {
                return _c(
                  "div",
                  {
                    staticClass: "xx-list-item",
                    on: {
                      click: function($event) {
                        return _vm.handleView(item)
                      }
                    }
                  },
                  [
                    _c(
                      "el-badge",
                      {
                        staticClass: "item",
                        attrs: { hidden: item.isOpen == 1, value: "未读" }
                      },
                      [
                        _c("div", { staticClass: "xx-title" }, [
                          _vm._v(_vm._s(item.content))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "xx-info" }, [
                          _c("div", [
                            _vm._v(
                              "时间：" +
                                _vm._s(_vm._f("formatDateTime")(item.sendTime))
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticStyle: { "margin-left": "30px" } },
                            [_vm._v("发件人：" + _vm._s(item.sendName))]
                          )
                        ]),
                        _vm._v(" "),
                        item.title
                          ? _c(
                              "el-button",
                              {
                                staticStyle: { "margin-top": "10px" },
                                attrs: { type: "success", size: "mini" },
                                on: {
                                  click: function($event) {
                                    return _vm.handleView(item)
                                  }
                                }
                              },
                              [_vm._v("点击回执")]
                            )
                          : _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function($event) {
                                    return _vm.handleView(item)
                                  }
                                }
                              },
                              [_vm._v("查看详情")]
                            )
                      ],
                      1
                    )
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _vm.pageTotal > 10
                ? _c("el-pagination", {
                    staticStyle: {
                      "margin-top": "20px",
                      position: "sticky",
                      bottom: "0",
                      "background-color": "#f7f7f7",
                      padding: "10px 0"
                    },
                    attrs: {
                      background: "",
                      layout: "prev, pager, next",
                      total: _vm.pageTotal
                    },
                    on: { "current-change": _vm.handlePageChange }
                  })
                : _vm._e()
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          key: _vm.message.id,
          attrs: {
            title: "消息详情",
            visible: _vm.viewDialogVisible,
            width: "800px",
            top: "50px",
            "show-close": false,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.viewDialogVisible = $event
            }
          }
        },
        [
          _c("Message", {
            attrs: { message: _vm.message },
            on: {
              readMessage: _vm.readMessage,
              updateMessageStatus: _vm.updateMessageStatus
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", icon: "el-icon-close" },
                  on: {
                    click: function($event) {
                      _vm.viewDialogVisible = false
                    }
                  }
                },
                [_vm._v("关闭")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ffce407", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ffce407","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/components/MessageList.vue
// module id = null
// module chunks = 